import { toast } from "react-toastify";
import { getApiBaseUrl } from "../utils/apiBaseUrl";

export interface ApiUser {
  id: number;
  userName: string;
  email: string;
  phoneNumber: string;
  isApiUser: boolean;
}

export const getAllApiUsers = async (
  token: string,
  t: (key: string) => string
): Promise<ApiUser[]> => {
  if (!token) {
    throw new Error("Token not found");
  }

  try {
    const baseUrl = getApiBaseUrl();

    const response = await fetch(
      `${baseUrl}/api/Admin/GetAllApiUsers`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch API users");
    }

    const data: ApiUser[] = await response.json();
    return data;
  } catch (error) {
    toast.error(t("somethingWentWrong"));
    throw error;
  }
};